import {
  fetchAllRetailersForRegion,
  getCachedRetailersForRegion,
} from "@/views/home/maptiler/useMapTilerAllStores";
import { getMapRegionDefaultLocation } from "@/utils/config";

/** 国家 Tab 切换：全量门店已缓存时立即切区，避免等接口 */
export function useMapTilerRegionSwitch({
  mapRegion,
  dealerList,
  listLoading,
  keyword,
  activeDealerKey,
  showMarkerPopup,
  innerDefaultMapCenter,
}) {
  let regionLoadToken = 0;

  const applyRegionMeta = (region) => {
    mapRegion.value = region;
    if (innerDefaultMapCenter) {
      Object.assign(innerDefaultMapCenter, getMapRegionDefaultLocation(region));
    }
  };

  const loadRegionDealers = async (region) => {
    const token = ++regionLoadToken;
    listLoading.value = true;
    try {
      const dealers = await fetchAllRetailersForRegion(region);
      if (token !== regionLoadToken) return;
      dealerList.value = dealers;
    } catch (e) {
      if (token !== regionLoadToken) return;
      dealerList.value = [];
    } finally {
      if (token === regionLoadToken) {
        listLoading.value = false;
      }
    }
  };

  const switchCountry = async (region) => {
    if (mapRegion.value === region) return;

    keyword.value = "";
    activeDealerKey.value = null;
    if (showMarkerPopup) showMarkerPopup.value = false;

    const cachedDealers = getCachedRetailersForRegion(region);

    if (cachedDealers) {
      regionLoadToken += 1;
      dealerList.value = cachedDealers;
      applyRegionMeta(region);
      listLoading.value = false;
      return;
    }

    dealerList.value = [];
    applyRegionMeta(region);
    await loadRegionDealers(region);
  };

  const loadInitialDealers = () => loadRegionDealers(mapRegion.value);

  return { switchCountry, loadInitialDealers };
}
